import qs from 'query-string';
import { KfaServiceHttpClient } from '../../common/services/httpClient';

export const postKfa = async (projectId, kfa) => {
  const response = await KfaServiceHttpClient.post(
    `/projects/${projectId}/KeyFocusAreas`,
    kfa
  );
  return response.data;
};

export const getKfa = async (projectId, keyFocusAreaId, shared = false) => {
  try {
    const response = await KfaServiceHttpClient.get(
      `/projects/${projectId}/${
        shared ? 'Shared' : ''
      }KeyFocusAreas/${keyFocusAreaId}${shared ? '' : '?draftLibraryItems=1'}`,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined
    );
    return response;
  } catch (e) {
    // eslint-disable-next-line no-console
    console.log(e);
    return null;
  }
};

export const getKfaSharedPrevious = async ({ contentID, projectID }) =>
  KfaServiceHttpClient.get(
    `/projects/${projectID}/kfa/content/${contentID}/previousversion`
  );

export const putKfa = async (projectId, kfa) => {
  const response = await KfaServiceHttpClient.put(
    `/projects/${projectId}/KeyFocusAreas/${kfa.contentId}`,
    kfa
  );

  return response.data;
};

export const getPagedDataForGrid = async (
  projectId,
  page = 0,
  pageSize = 3,
  tagsIds,
  shared = false
) => {
  const response = await KfaServiceHttpClient.get(
    `/projects/${projectId}/${shared ? 'Shared' : ''}KeyFocusAreas/grid${
      tagsIds
        ? `?${qs.stringify({ TagIds: tagsIds })}`
        : `?currentPage=${page}&pageSize=${pageSize}`
    }`
  );
  return response.data;
};

export const getPagedDataForList = async (
  projectId,
  page = 0,
  pageSize = 3,
  sortKey = 'sortOrder',
  isDescending = false,
  tagIds,
  shared = false
) => {
  const response = await KfaServiceHttpClient.get(
    `/projects/${projectId}/${shared ? 'Shared' : ''}KeyFocusAreas/list${
      tagIds
        ? `?${qs.stringify({
            TagIds: tagIds,
          })}&sortBy=${sortKey}&sortDescending=${isDescending.toString()}`
        : `?currentPage=${page}&pageSize=${pageSize}&sortBy=${sortKey}&sortDescending=${isDescending.toString()}`
    }`
  );
  return response.data;
};

export const getKfaVersions = async (
  projectId,
  hypothesisContentThreadId,
  shared
) => {
  const response = await KfaServiceHttpClient.get(
    `/projects/${projectId}/${
      shared ? 'Shared' : ''
    }KeyFocusAreas/${hypothesisContentThreadId}/versions`
  );
  return response.data;
};
